<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div v-if="onlineDetails.proximoACaducar" class="col-md-12 alert alert-danger" role="alert">
                    <strong>{{$t('atencion')}}</strong>, {{$t('suLicenciaDeNumierOnlineEstaAPuntoDeCaducar')}}
                </div>
                <div class="card-columns">
                    <div class="card">
                        <div class="card-header">
                            <h4 class="card-title">
                                {{$t("totalVenta")}}
                            </h4>
                            <p class="card-category">
                                {{$t("totalEnDirectoPorNegocio")}}
                            </p>
                        </div>

                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-8">
                                    <table class="table" id="tabletotalventa">
                                        <tbody>
                                        <template v-for="(tpv, index) in onlineDetails.listTpvs">
                                            <tr class="titletpv">
                                                <td style="padding: 3px" align="center">
                                                    <span :style="{'background-color': colors[index]}"
                                                          class="colorTpv"></span>
                                                </td>
                                                <td>
                                                    <div class="check-tpv">
                                                        <input type="checkbox" class="form-check-input" :id="tpv.idTpv"
                                                               v-model="tpv.checked" @change="setupDetails">
                                                        <label style="font-weight: bold"
                                                               :style="{'color': colors[index]}" :for="tpv.idTpv">
                                                            {{tpv.nameShow}}
                                                        </label>
                                                    </div>
                                                </td>
                                                <td align="right" v-if="tpv.online == 1">
                                                    <span><small>(<span
                                                            class="text-warning">{{tpv.pending | currency}}</span> + <span
                                                            class="text-primary">{{tpv.cards + tpv.checks | currency}}</span> + <span
                                                            style="color: #0f6674">{{tpv.money | currency}}</span>
                                                            <span v-if="tieneSaldo" >
                                                                <span>+</span>
                                                                <span style='color: #E43500' > {{tpv.pagoSaldo | currency}}</span>
                                                            </span>
                                                             )</small>
                                                            
                                                            </span>
                                                    <span class="text-success"><strong>{{tpv.value | currency}}</strong></span>
                                                </td>
                                                <td align="right" v-else>
                                                    <span class="text-secondary">{{$t("cajaCerrada")}}</span>
                                                </td>
                                            </tr>
                                        </template>
                                        </tbody>
                                        <tfoot class="foot-total">
                                        <tr class="bg-secondary">
                                            <td colspan="2">{{$t("total")}}</td>
                                            <td align="right">{{totalTpvs | currency}}</td>
                                        </tr>
                                        </tfoot>
                                    </table>

                                    <div class="legend">
                                        <i class="fa fa-circle text-warning"></i> {{$t("enCuenta")}}
                                        <i class="fa fa-circle text-primary"></i> {{$t('tarjetaYCheques')}}
                                        <i class="fa fa-circle" style="color: #0f6674"></i> {{$t('efectivo')}}
                                        <i class="fa fa-circle text-success"></i> {{$t("cobrado")}}
                                        <div v-if="tieneSaldo"><i class="fa fa-circle" style='color: #E43500'></i> {{$t("saldo")}} </div>
                                        
                                    </div>
                                </div>

                                <div class="col-md-4 wrap-chart">
                                    <canvas id="chart-total"></canvas>
                                </div>
                            </div>

                        </div>
                        <div class="card-footer">
                            <hr>
                            <div class="stats">
                                <i class="fa fa-clock"></i> {{onlineDetails.lastDate | timeago}}
                            </div>
                        </div>
                    </div>

                    <total-caja :onlineDetails="listOnlineDetails" :lastDate=onlineDetails.lastDate></total-caja>
                    
                    <tickets v-if="listOnlineDetails.length>0" :onlineDetails="listOnlineDetails"
                             :lastDate=onlineDetails.lastDate :idBusiness="idBusiness"></tickets>

                    <productos-mas-vendidos v-if="listOnlineDetails.length>0" :onlineDetails="listOnlineDetails"
                                            :lastDate=onlineDetails.lastDate
                                            :idBusiness="idBusiness"></productos-mas-vendidos>

                    <consumo-horas v-if="listOnlineDetails.length>0" :onlineDetails="listOnlineDetails"
                                   :lastDate=onlineDetails.lastDate :idBusiness="idBusiness"></consumo-horas>
                    
                    <pedidos-horas v-if="listOnlineDetails.length>0" :onlineDetails="listOnlineDetails"
                                               :lastDate=onlineDetails.lastDate :idBusiness="idBusiness"></pedidos-horas>
    
                    <consumo-fechas-anteriores v-if="listOnlineDetails.length>0" :onlineDetails="listOnlineDetails"
                                               :lastDate=onlineDetails.lastDate :idBusiness="idBusiness">
                    </consumo-fechas-anteriores>
                    
                    <turnos-operarios
                            v-if="listOnlineDetails.length>0"
                            :onlineDetails="listOnlineDetails"
                            :lastDate=onlineDetails.lastDate
                            :idBusiness="idBusiness"></turnos-operarios>
                    <planos-mesas
                            v-if="listOnlineDetails.length>0 && soloRetail"
                            :onlineDetails="listOnlineDetails"
                            :lastDate=onlineDetails.lastDate
                            :idBusiness="idBusiness">
                    </planos-mesas>
                    <cajon-inteligente v-if="listOnlineDetails.length>0" :onlineDetails="listOnlineDetails"
                                       :lastDate=onlineDetails.lastDate
                                       :idBusiness="idBusiness"></cajon-inteligente>


                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import swal from 'sweetalert2'
    import {Switch} from 'element-ui'
    import TotalCaja from './Widgets/TotalCaja.vue'
    import Tickets from './Widgets/Tickets.vue'
    import ProductosMasVendidos from './Widgets/ProductosMasVendidos.vue'
    import ConsumoHoras from './Widgets/ConsumoHoras.vue'
    import ConsumoFechasAnteriores from './Widgets/ConsumoFechasAnteriores.vue'
    import TurnosOperarios from "./Widgets/TurnosOperarios.vue";
    import PlanosMesas from "./Widgets/PlanoMesas.vue"
    import CajonInteligente from "./Widgets/CajonInteligente";
    import PedidosHoras from "./Widgets/PedidosHoras.vue";

    export default {

        created() {
            this.$store.dispatch("setNameRoute", this.$i18n.t("cajasOnlineDetalles"));
            this.getOnlineDetails();
            this.getConfigTpvRetail();
            

        },

        components: {
            CajonInteligente,
            TurnosOperarios,
            [Switch.name]: Switch,
            'total-caja': TotalCaja,
            'tickets': Tickets,
            'consumo-fechas-anteriores': ConsumoFechasAnteriores,
            'productos-mas-vendidos': ProductosMasVendidos,
            'consumo-horas': ConsumoHoras,
            'pedidos-horas': PedidosHoras,
            PlanosMesas
        },
        data() {
            return {
                onlineDetails: {},
                $Chart: null,
                objectChart: null,                
                colors: [
                    "rgb(66, 7, 140)",
                    "rgb(91, 142, 14)",
                    "rgb(8, 6, 135)",
                    "rgb(175, 10, 73)",
                    "rgb(81, 3, 150)",
                    "rgb(10, 110, 130)",
                    "rgb(202, 14, 209)",
                    "rgb(83, 11, 114)",
                    "rgb(30, 0, 140)",
                    "rgb(153, 34, 13)"
                ],
                tieneSaldo: false,
                soloRetail:true,
            }
        },
        methods: {

            
            getConfigIniTpvSaldo(idTpv){
                
                let saldoConfig = 2;
                var config = {
                    params: {
                    idTpv : idTpv,
                    jwt: this.$store.getters.jwt,
                    idIni: saldoConfig,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                let vm = this;
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                this.axios
                    .get(this.$store.getters.apiUrl + "general/getConfigIniByTpv", config)
                    .then(function(response) {
                      
                        if(response.data.response){
                            
                            vm.tieneSaldo = response.data.response;
                        }
                    })
                    .catch(function(error) {
                    console.log(error);
                    });
            },

            getConfigTpvRetail() {
                var config = {
                    params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                    numConfig: 84,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                let vm = this;
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                this.axios
                    .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
                    .then(function(response) {
                        
                    if (response.data.response) {
                        
                        vm.soloRetail = false;
                    }
                    })
                    .catch(function(error) {
                    console.log(error);
                    });
             },
            getOnlineDetails() {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "online/getOnlineDetails", config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.onlineDetails = response.data.result;
                            vm.setupDetails();

                            
                            if (vm.onlineDetails.listTpvs){
                                vm.onlineDetails.listTpvs.forEach(tpv => {
                                vm.getConfigIniTpvSaldo(tpv.idTpv);    
                                });
                                
                            }

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            setupDetails() {
                this.initCharOnlineDetails();
            },
            initCharOnlineDetails() {
                if (this.onlineDetails.listTpvs) {
                    var labels = this.onlineDetails.listTpvs.map(function (x) {
                        if (x.checked) {
                            return x.nameShow;
                        }
                    });


                    var data = this.onlineDetails.listTpvs.map(function (x) {
                        if (x.checked) {
                            return x.value;
                        }
                    });


                    var randomColor = require('randomcolor');

                    let backgroundColors = this.colors.map(function (x) {
                        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                        return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)";
                    });

                    let borderColors = this.colors.map(function (x) {
                        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                        return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.3)";
                    });

                    let hoverBackgroundColors = this.colors.map(function (x) {
                        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                        return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 1)";
                    });

                    if (this.$chart) {
                        this.$chart.destroy();
                    }

                    this.$chart = new Chart("chart-total", {
                        type: 'pie',
                        data: {
                            labels: labels,
                            datasets: [{
                                data: data,
                                backgroundColor: backgroundColors,
                                borderColor: borderColors,
                                hoverBackgroundColor: hoverBackgroundColors,
                                borderWidth: 1
                            }]
                        }, options: {
                            legend: {
                                display: false,
                            }
                        }
                    });

                }
            }
        },
        computed: {
            idBusiness() {
                return this.$route.params.idBusiness;
            },
            listOnlineDetails() {
                var list = {};

                if (this.onlineDetails.listTpvs) {
                    list = this.onlineDetails.listTpvs.map(function (x) {
                        if (x.checked) {
                            return x;
                        }
                    });
                }

                return list;
            },
            totalTpvs() {
                var total = 0;

                if (this.onlineDetails.listTpvs) {
                    for (var i = 0; i < this.onlineDetails.listTpvs.length; i++) {
                        total += this.onlineDetails.listTpvs[i].value;
                    }
                }

                return total;
            }
        }

    }
</script>
<style scoped>
    .card-body {
        padding: 10px 15px;
    }

    #tabletotalventa td {
        padding: 5px 15px;
    }

    .wrap-chart {
        margin-top: 10px;
        padding: 0px;
    }

    .foot-total tr td {
        font-size: 1.2em;
        color: #fff;
        text-shadow: 1px 1px #111;
        font-weight: bold;
    }

    .check-tpv {
        padding-left: 1em;
    }

    .check-tpv label {
        margin-bottom: 0px;
    }

    .check-tpv label:hover {
        cursor: pointer;
    }

    .progress {
        height: 10px !important;
        margin-bottom: 0px;
    }

    .progresstpv td {
        border-top: none;
    }

    .card-columns {
        column-count: 2;

    }

    @media (max-width: 767.98px) {
        .card-columns {
            column-count: 1;

        }
    }

    .colorTpv {
        padding: 0px 8px;
        border-radius: 4px;
    }

    .card-category {
        color: #9a9a9a
    }


</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Online/OnlineDetails.vue